import { useCallback, useSyncExternalStore } from 'react';

/** Tablets and phones. Keep in step with the `max-width: 1024px` CSS blocks. */
export const COMPACT_QUERY = '(max-width: 1024px)';
/** Phones. Keep in step with the `max-width: 640px` CSS blocks. */
export const PHONE_QUERY = '(max-width: 640px)';

/** Live result of a CSS media query; re-renders when it flips (rotation, resize, split view). */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false,
  );
}
